import { DhlPopover as NewPopover } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for Popover component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Popover = (props) => {
  const {
    closeButtonAriaLabel,
    popoverTriggerAriaLabel,
    popperOptions,
    triggerEl,
    children,
    ...rest
  } = props;

  const newProps = {
    ...rest,
    closeButtonLabel: closeButtonAriaLabel,
    triggerLabel: popoverTriggerAriaLabel,
    trigger: triggerEl,
    placement: "auto",
    modifiers: popperOptions?.modifiers || [],
  };

  return <NewPopover {...newProps}>{children}</NewPopover>;
};

Popover.propTypes = {
  closeButtonAriaLabel: PropTypes.string,
  offset: PropTypes.any,
  popoverTriggerAriaLabel: PropTypes.string,
  popperOptions: PropTypes.object,
  triggerEl: PropTypes.node,
  children: PropTypes.node,
};
